import React from 'react';
import { Sun, Moon } from '@gravity-ui/icons';
import { ThemeType, Icon, Button } from '@gravity-ui/uikit';

type ThemeSwitcherProps = {
    onUpdate: (theme: string) => void;
    theme: ThemeType;
    className?: string;
    hidden?: boolean;
};

const options = [
    { value: 'light', content: <Icon data={Sun} size={20} /> },
    { value: 'dark', content: <Icon data={Moon} size={20} /> },
];

const getThemeInfo = (theme: ThemeType) => {
    const currentThemeIdx = options.findIndex(({ value }) => value === theme);
    const nextThemeIdx = (currentThemeIdx + 1) % options.length;
    return {
        currentIdx: currentThemeIdx,
        nextIdx: nextThemeIdx,
    };
};

export function ThemeSwitcher({ onUpdate, theme, className, hidden = false }: ThemeSwitcherProps) {
    const { currentIdx, nextIdx } = getThemeInfo(theme);
    const visibility = hidden ? 'hidden' : 'visible';
    return (
        <Button
            size="s"
            view="flat"
            onClick={() => onUpdate(options[nextIdx].value)}
            className={className}
            style={{ visibility }}
        >
            {options[currentIdx].content}
        </Button>
    );
}
